export const cashflowPtBr = {
  filters: {
    excludeUnscheduled: 'Excluir saldos sem pagamento cadastrado',
    excludedSummary:
      '{{count}} conta(s) com saldo excluído: {{amount}}. As recorrências futuras continuam na projeção.',
  },
  fx: {
    historicalRecovery:
      'Esta pendência é de uma data histórica. Regularize a cotação de fechamento na central de câmbio.',
    openRecovery: 'Abrir central de câmbio',
    unknownCurrency: 'Moeda não informada',
    title: 'Câmbio da projeção',
    rate: 'Taxa',
    date: 'Data da cotação',
    source: 'Fonte',
    incomplete:
      'Projeção incompleta: há valores sem conversão. Os totais e indicadores estão indisponíveis até resolver as pendências.',
    subtotals: 'Subtotais convertidos — não representam o fluxo de caixa completo',
    manualQuote: 'Informar cotação',
    editRate: 'Editar',
    currency: 'Moeda de apresentação',
    unresolved: 'Valores pendentes de conversão',
    pending:
      'Cotação enviada para aprovação por outra pessoa. A projeção usará a taxa após a aprovação.',
  },
  title: 'Fluxo de Caixa',
  subtitle: 'Projeção consolidada · {{date}}',
  entitySubtitle: 'Projeção da entidade · {{date}}',
  entity: {
    allConsolidated: 'Todas as entidades (consolidado)',
    entityA: 'Alchemy Tecnologia Ltda',
    entityB: 'Alchemy Filial SP',
  },
  period: {
    weeks: '13 semanas',
    days: '14 dias',
  },
  actions: {
    manualEntry: 'Lançamento manual',
    export: 'Exportar',
    exportToast: 'Exportação ainda não disponível nesta versão.',
  },
  alerts: {
    bannerLabel: 'Avisos do fluxo de caixa',
    openWarnings: 'Avisos: {{label}}',
    warningDetails: 'Confira as limitações e pendências que afetam estes valores.',
    bankBalanceUnavailable:
      'Não há saldo bancário disponível para a data de referência. Caixa e runway não podem ser apurados; a tabela mostra a variação acumulada das entradas e saídas, sem saldo inicial.',
    bankConnectionExpired:
      'Conexão {{bank}} expirada — dados desta conta refletem {{date}}. O saldo consolidado pode estar defasado.',
    bankConnectionExpiredNoSync:
      'Conexão {{bank}} ainda não sincronizou. O saldo consolidado pode estar defasado.',
    bankConnectionPendingAuth:
      'Open finance - Sua instituição bancária aguarda autorização, o saldo consolidado pode estar defasado',
    unknownBank: 'sua instituição bancária',
    openPluggy: 'Integrações',
    liquidityGap: {
      title: '{{entityName}}: saldo projetado abaixo do piso de liquidez',
      message:
        'No período {{week}}, o saldo projetado fica {{shortfall}} abaixo do piso de {{floor}}.',
      leversLabel: 'Ações recomendadas (apenas sugestão — nenhuma é executada automaticamente):',
    },
    idleCash: {
      title: '{{entityName}}: caixa ocioso identificado',
      message:
        'O saldo consolidado está em {{balance}}, acima do piso + buffer de {{threshold}} há {{days}} dias seguidos. Pode ser uma oportunidade para aplicar o excedente.',
    },
  },
  summary: {
    balanceUnavailable: 'Indisponível',
    currentBalance: {
      label: 'Saldo atual consolidado',
      hint: '{{accounts}} · {{freshness}}',
      noAccounts: 'nenhuma conta',
      accountsCount_one: '{{count}} conta {{currency}}',
      accountsCount_other: '{{count}} contas {{currency}}',
      noData: 'sem dados de saldo',
      updatedToday: 'atualizado hoje',
      updatedOn: 'atualizado em {{date}}',
    },
    expandedCash: {
      label: 'Caixa ampliado',
      hint: 'inclui {{amount}} em aplicações D+0',
      tooltip:
        'Visão de liquidez que soma o saldo em contas correntes com as aplicações financeiras de resgate imediato ou quase imediato. A ideia é responder "quanto dinheiro eu consigo mobilizar hoje se precisar?" em vez de apenas "quanto está parado na conta". Você pode editar quais investimentos são computados',
      tooltipLink: 'Aqui.',
    },
    burn: {
      label: 'Burn líquido mensal',
      hint: 'média mensal das saídas líquidas projetadas',
    },
    runway: {
      label: 'Runway',
      hint: 'caixa ampliado ÷ burn médio',
      months: '{{value}} meses',
      notBurning: 'Sem queima de caixa',
    },
    lowestBalance: {
      label: 'Menor saldo projetado',
      hint: 'semana de {{range}}',
      dailyHint: 'dia {{range}}',
    },
  },
  table: {
    title: 'Projeção semanal · 13 semanas',
    dailyTitle: 'Projeção diária · 14 dias',
    confidence: 'Confiança da projeção: {{value}}%',
    confidenceHelp:
      'Score indicativo pela origem dos valores: Realizado {{realized}}, Comprometido {{committed}}, Previsto {{forecastAi}} e Planejado {{planned}}.\n\nÉ a média desses scores ponderada pelo valor absoluto de cada célula de categoria no período exibido. Quando uma célula mistura classificações, vale o menor score. Células vazias ou zeradas não entram; sem valores, o score é 0%.\n\nNão é uma probabilidade de acerto: não mede dados ausentes, qualidade das datas ou erros históricos.',
    legend: {
      realized: 'Realizado',
      committed: 'Comprometido',
      forecastAi: 'Previsto',
      planned: 'Planejado',
    },
    legendHelp: {
      realized:
        'Entrada ou saída efetivamente realizada, com registro de pagamento ou recebimento.',
      committed:
        'Valor de um documento já existente, como uma conta a pagar ou a receber. Pode ainda não ter pagamento cadastrado e a data pode ser estimada.',
      forecastAi:
        'Estimativa gerada a partir de recorrências, pedidos de compra, contratos ou folha, ainda sem o título correspondente. É substituída pelo documento quando ele é criado.',
      planned:
        'Lançamento manual incluído na projeção. Não tem baixa automática: ajuste ou remova o planejado quando o documento correspondente for registrado, para evitar duplicidade.',
    },
    viewMode: {
      managerial: 'Visão gerencial (burn)',
      detailed: 'Visão operacional (detalhada)',
    },
    columns: {
      category: 'Categoria',
    },
    sections: {
      inflows: 'Entradas',
      outflows: 'Saídas',
    },
    rows: {
      totalInflows: 'Total entradas',
      totalOutflows: 'Total saídas',
      netChange: 'Variação líquida',
      closingBalance: 'Saldo final projetado',
      cumulativeNetChange: 'Variação acumulada (sem saldo inicial)',
    },
    footnote:
      'Datas previstas ajustadas pelo comportamento de pagamento de cada cliente. Clique em qualquer célula para ver os documentos de origem.',
    dateEstimatedHint:
      'Inclui datas estimadas a partir de vencimentos, histórico ou premissas de pagamento. Consulte o detalhamento para conferir a origem.',
    amountEstimatedHint:
      'Inclui valores estimados, que podem variar em relação ao pagamento efetivo. Consulte o detalhamento para conferir a origem e as premissas.',
    // ALC-4191 — the one sentence that makes the memo row honest: the figure is real and
    // drillable, but it is in no total on this screen.
    memoRowHint:
      'Linha informativa: estes valores não entram nos totais, no saldo projetado nem nos alertas. Clique para ver os documentos.',
    // ALC-3562 — a payroll forecast cell has no periodId of its own (it aggregates every stream
    // due that week), so this is a period-free line distinct from the drill-down row, which does
    // carry one. See CONTEXT under "Scope deviations" in the PR for why. Deliberately hedged
    // ("pode incluir", never "inclui"): a confidential recurring-bill template's own projected
    // occurrence is also masked into this same FORECAST_AI payroll row, so the cell isn't
    // exclusively Alchemy ERP's own payroll forecast — only the drill-down knows the exact mix.
    payrollForecastHint:
      'Pode incluir previsão de folha gerada pelo Alchemy ERP — veja o detalhamento da célula.',
    payrollCalendarNotConfigured:
      'Nenhum calendário de pagamento configurado para esta rubrica — projeção nas datas legais padrão.',
    payrollCalendarNotConfiguredLink: 'Configurar calendário de pagamento',
  },
  drilldown: {
    contracts_one: 'Contrato: {{codes}}',
    contracts_other: 'Contratos: {{codes}}',
    inferredDue: 'Vencimento inferido',
    editCashTiming: 'Clique para alterar a configuração.',
    cashCalendarWeekdays: 'dias da semana (0 = domingo)',
    cashCalendarMonthDays: 'dias do mês',
    cashDateBasis: {
      DOCUMENT_DUE_DATE: 'vencimentos documentais',
      SCHEDULED_DATE: 'datas agendadas',
      MIXED: 'vencimentos documentais e datas agendadas',
    },
    cashDateSources: {
      MANUAL_TERM: 'Prazo manual: competência + {{days}} dias corridos.',
      HISTORICAL_TERM:
        'Histórico da recorrência: competência + {{days}} dias. Mediana de {{count}} competência(s), usando {{basis}}.',
      ENTITY_CALENDAR:
        'Próxima data do calendário da entidade após a competência: {{calendar}} — {{dates}}.',
      COMPETENCY_FALLBACK: 'Sem prazo, histórico ou calendário. Usa a própria competência (D+0).',
    },

    title: '{{category}} · {{week}}',
    loading: 'Carregando documentos…',
    description: 'Documentos que compõem o valor desta célula.',
    filters: {
      filter: 'Filtrar {{column}}',
      search: 'Buscar fornecedor ou descrição',
      all: 'Todas as classificações',
      minimum: 'Valor mínimo',
      maximum: 'Valor máximo',
      signedAmounts:
        'Use valores negativos para saídas e positivos para entradas, na moeda da projeção.',
      clearAll: 'Limpar filtros e ordenação',
    },
    projectionDateHelp: 'Como a data na projeção é definida',
    projectionDateTooltip:
      'Data em que o valor entra no fluxo de caixa.\n\nPagamento agendado: data agendada.\nConta sem agendamento: vencimento; se ausente, uma estimativa pela condição de pagamento ou pelo prazo padrão.\nMovimentação realizada: data do lançamento bancário.\n\nPendências anteriores ao início da projeção entram no início do primeiro período. Nesse caso, a data exibida não é o vencimento original nem um novo agendamento.',
    columns: {
      document: 'Documento',
      date: 'Data na projeção',
      // ALC-4218 — AP rows only; every other document leaves these cells empty.
      dueDate: 'Vencimento',
      scheduledDate: 'Agendado',
      paymentSentAt: 'Data envio pagamento',
      layer: 'Classificação',
      amount: 'Valor',
    },
    // ALC-4218 — bank state of an outstanding AP payment; replaces the layer badge when set.
    paymentStates: {
      AWAITING_BANK_CONFIRMATION: 'Ag. Confirmação Pgto',
      FAILED: 'Falhou – reenviar',
    },
    paymentStatesHelp: {
      AWAITING_BANK_CONFIRMATION:
        'O pagamento foi enviado ao banco e aguarda a confirmação. O valor continua como comprometido.',
      FAILED:
        'O banco recusou o pagamento. Reenvie-o para que saia na data prevista. O valor continua como comprometido.',
    },
    loadError: 'Não foi possível carregar os documentos de origem.',
    empty: 'Nenhum documento encontrado para esta célula.',
    openSource: 'Abrir documento de origem',
    documentTypes: {
      bankTransaction: 'Transação bancária',
      apPayment: 'Pagamento a fornecedor',
      apBill: 'Conta a pagar (data estimada)',
      cardStatement: 'Fatura de cartão',
      loanInstallment: 'Parcela de empréstimo',
      arSchedule: 'Recebível',
      cfManualItem: 'Lançamento manual',
      apVendorRecurringBill: 'Recorrência',
      purchaseOrder: 'Pedido de compra (previsão)',
      hcmPayrollForecast: 'Folha projetada (previsão)',
      // ALC-4194 (ADR 0018) — cartão sem fatura viva: a estimativa vem dos pagamentos e das contas.
      uncoveredCardEstimate: 'Cartão sem fatura (estimado)',
      costProvision: 'Custo provisionado',
    },
    // ALC-4194 — as parcelas da estimativa de um cartão sem fatura viva. "Abate" é um crédito:
    // reduz a estimativa (faturas já pagas, fatura agendada que já sai pelo banco).
    uncoveredCardComponents: {
      UNCOVERED_CARD_CYCLE_CHARGES: 'Compras no cartão nos 2 últimos ciclos',
      UNCOVERED_CARD_PAID_INVOICES: 'Abate: faturas já pagas',
      UNCOVERED_CARD_OPEN_BILLS: 'Contas em aberto',
      UNCOVERED_CARD_SCHEDULED_INVOICE_PAYMENTS: 'Abate: fatura agendada no banco',
    },
    uncoveredCardEstimateNotice:
      'Valor estimado a partir de pagamentos e contas. Importe a fatura do cartão para ver o valor exato.',
    // ALC-4191 — stable reason codes for the "Provável cartão (não somado)" memo row.
    probableCardReasons: {
      VENDOR_LAST_PAID_BY_CARD: 'Último pagamento no cartão',
      CARD_MATCH_CANDIDATE: 'Sugestão de conciliação com cartão',
    },
    // ALC-4191 (D9) — a conta na linha memo mostra de qual categoria ela saiu, já que a regra
    // não olha a natureza da conta.
    originCategory: 'Origem: {{category}}',
    payrollForecast: {
      sourceRunPeriod: 'Baseado na folha de {{period}}',
      noSourceRunPeriod: 'Sem folha de referência',
    },
    // ALC-4192 — fatura remainder breakdown shown on a CARD_STATEMENT drill-down row.
    cardStatementBreakdown: {
      // ALC-4192 — "line" not "fatura": on the fees/IOF row this is the fees total, not the
      // whole statement's total. Payment settles the principal row first and only spills onto
      // this one once the principal is covered, so its "Pago" is usually — but not always — 0.
      total: 'Total da linha',
      paid: 'Pago',
      remainder: 'Restante',
    },
  },
  // ALC-3561 — copy for the payroll forecast contract. Keys mirror the producer's stable
  // warning codes 1:1; the API never sends a message, only the code.
  payrollForecast: {
    streams: {
      NET: 'Salários líquidos',
      ADVANCE: 'Adiantamento',
      PRO_LABORE: 'Pró-labore',
      RPA: 'RPA (autônomos)',
      REPASSE: 'Repasses a terceiros',
      THIRTEENTH_1: '13º — 1ª parcela',
      THIRTEENTH_2: '13º — 2ª parcela',
      TERMINATION: 'Verbas rescisórias',
    },
    sources: {
      ROLL_FORWARD: 'Projetado a partir da última folha',
      PLAN_POSITION: 'Posição do plano de contratações',
      TERMINATION_ADJUSTMENT: 'Ajuste por rescisão',
      PROCESSED_RUN: 'Folha processada, aguardando contabilização',
    },
    ferias: {
      label: 'Provisão de férias',
      undatedTitle: 'Obrigações sem cronograma de pagamento',
      undatedHint: 'Saldos contábeis informativos. Não compõem as saídas nem o saldo projetado.',
      byEntity: 'Detalhamento por entidade',
      entityUnavailable: 'Entidade não identificada',
      unavailable: 'Saldo indisponível. Consulte os avisos para verificar os dados necessários.',
      // The figure is the provision balance only — INSS/FGTS over the provision is not in it.
      hint: 'Provisão contábil acumulada, sem data de pagamento. Não compõe as saídas semanais nem o saldo projetado. Não inclui INSS/FGTS sobre a provisão.',
      value: '{{amount}} · sem data',
      flagged: 'Saldo da provisão negativo no razão — exibido como zero. Verifique os lançamentos.',
      mixedCurrency: 'Entidades com moedas funcionais diferentes — total consolidado indisponível.',
      byEntityLine: '{{entityName}}: {{amount}}',
    },
    warnings: {
      PAYROLL_CALENDAR_DECLARED_NO_RUN:
        'Calendário de pagamento declarado, mas não há folha processada nas últimas 2 competências — nenhuma projeção foi gerada para esta rubrica.',
      PAYROLL_RUN_NOT_IN_CALENDAR:
        'Há folha desta rubrica, mas ela não está declarada no calendário de pagamento — projetada na data legal padrão.',
      PAYROLL_CALENDAR_NOT_CONFIGURED:
        'Nenhum calendário de pagamento configurado — projeção nas datas legais padrão.',
      PAYROLL_FORECAST_CONFIDENTIAL:
        'Detalhes ocultos pelo seu nível de acesso. Alertas agregados: {{coverageIssueCount}} de cobertura e {{estimateIssueCount}} de premissa ou defasagem.',
      PAYROLL_NEW_HIRES_AFTER_LAST_RUN:
        'Há admissões posteriores à última folha. A projeção ainda não reflete esses contratos.',
      PAYROLL_LAST_RUN_STALE:
        'A última folha desta entidade tem mais de 2 competências. O valor projetado pode estar defasado.',
      PAYROLL_ROSTER_UNAVAILABLE:
        'Não foi possível carregar o quadro de pessoal de FP&A desta entidade — a projeção não considera admissões nem desligamentos planejados.',
      PAYROLL_MONTHLY_BASE_MISSING:
        'Há adiantamento CLT, mas não há folha mensal para estimar o saldo salarial e o 13º. A previsão de folha está incompleta; importe a folha mensal para completar a base.',
      PAYROLL_FERIAS_UNAVAILABLE: 'Não foi possível apurar a provisão de férias desta entidade.',
      PAYROLL_FERIAS_MIXED_CURRENCY:
        'As entidades selecionadas não compartilham a mesma moeda funcional — o total de férias não é somado.',
      PAYROLL_RUN_CURRENCY_MISMATCH:
        'A última folha está em moeda diferente da moeda funcional da entidade e foi ignorada — nenhuma projeção para esta rubrica.',
      PAYROLL_RUN_TOTAL_MISMATCH:
        'O total no cabeçalho da folha diverge da soma dos resultados. A previsão usa os resultados, assim como a contabilização.',
      PAYROLL_REPASSE_MAPPING_UNAVAILABLE:
        'Não foi possível verificar os repasses desta folha por falta de configuração do livro ou período contábil. O valor líquido continua na projeção.',
      PAYROLL_REPASSE_PENDING_POSTING:
        'A folha contém descontos com repasse a terceiros, mas ainda não foi contabilizada. Os repasses entram na projeção pelo valor descontado até a geração dos títulos.',
      PAYROLL_FX_RATE_UNAVAILABLE:
        'Sem taxa de câmbio para converter a folha desta entidade à moeda do relatório na data de referência — a projeção está incompleta e a linha permanece na lista de itens sem conversão.',
      PAYROLL_PROCESSED_OVERDUE_UNBILLED:
        'A data prevista de pagamento passou e a folha processada ainda não gerou títulos. O valor líquido permanece na semana atual como pendência; isso não confirma falta de pagamento bancário.',
      PAYROLL_THIRTEENTH_NET_BELOW_PARCELA_1:
        'O líquido da folha-base é menor que a 1ª parcela do 13º, então a 2ª parcela foi estimada pelo mesmo valor da 1ª — o desembolso de dezembro pode estar um pouco alto; confira a folha-base.',
    },
    banner: {
      title: 'Avisos da previsão de folha',
      withEntity: '{{entityName}}: {{message}}',
      runContext: 'Competência {{period}} · {{runType}} · pagamento previsto {{cashDate}}',
      dateUnknown: 'não informado',
    },
  },
  categories: {
    clientPayments: 'Recebimentos de clientes',
    recurringContracts: 'Contratos recorrentes (a faturar)',
    oneOffServices: 'Serviços avulsos (previsto)',
    suppliers: 'Fornecedores',
    payroll: 'Folha e encargos',
    taxes: 'Impostos e guias',
    cardBills: 'Faturas de cartão',
    cardFinanceCharges: 'Juros e encargos de cartão',
    loans: 'Empréstimos',
    bankFees: 'Tarifas bancárias',
  },
  manualEntry: {
    title: 'Novo lançamento manual',
    description:
      'Registre uma entrada ou saída prevista que ainda não está refletida automaticamente no fluxo de caixa.',
    directionLabel: 'Tipo de lançamento',
    inflow: 'Entrada',
    outflow: 'Saída',
    entityLabel: 'Entidade',
    categoryLabel: 'Categoria',
    categoryPlaceholder: 'Selecione uma categoria',
    categoryOther: 'Outro',
    activityLabel: 'Atividade CPC-03',
    activityPlaceholder: 'Selecione a atividade econômica',
    activityOperating: 'Operacional',
    activityInvesting: 'Investimento',
    activityFinancing: 'Financiamento',
    dateLabel: 'Data prevista',
    amountLabel: 'Valor',
    descriptionLabel: 'Descrição',
    descriptionPlaceholder: 'Detalhes do lançamento (opcional)',
    cancel: 'Cancelar',
    save: 'Salvar lançamento',
    update: 'Salvar alterações',
    edit: 'Editar',
    delete: 'Excluir',
    deleteConfirmTitle: 'Excluir lançamento planejado?',
    deleteConfirmDescription:
      'O lançamento será removido da projeção de fluxo de caixa. Esta ação não pode ser desfeita.',
    deleteConfirmAction: 'Excluir',
    itemsTitle: 'Lançamentos planejados',
    deletedToast: 'Lançamento removido do fluxo de caixa.',
    deleteErrorToast: 'Não foi possível excluir o lançamento.',
    loadError: 'Não foi possível carregar os dados do lançamento.',
    retry: 'Tentar novamente',
    savedToast: 'Lançamento adicionado ao fluxo de caixa.',
    saveErrorToast: 'Não foi possível salvar o lançamento. Tente novamente.',
    loading: 'Carregando entidades…',
    noEntities: 'Nenhuma entidade encontrada.',
  },
  liquidityConfig: {
    trigger: 'Piso de liquidez',
    title: 'Piso de liquidez',
    description:
      'Defina o saldo mínimo por entidade. Um alerta é disparado quando o saldo projetado de uma semana fica abaixo desse piso.',
    entityLabel: 'Entidade',
    floorLabel: 'Piso de liquidez',
    suggestedHint: 'Sugestão baseada no burn mensal atual. Você pode ajustar antes de salvar.',
    bufferLabel: 'Buffer de caixa ocioso',
    sustainedDaysLabel: 'Dias sustentados',
    cancel: 'Cancelar',
    save: 'Salvar',
    savedToast: 'Piso de liquidez salvo.',
    saveErrorToast: 'Não foi possível salvar o piso de liquidez.',
    loading: 'Carregando…',
    loadError: 'Não foi possível carregar a configuração.',
    retry: 'Tentar novamente',
    noEntities: 'Nenhuma entidade cadastrada ainda para configurar um piso de liquidez.',
  },
  monthly: {
    pageTitle: 'Fluxo de caixa mensal',
    entityLabel: 'Entidade',
    rangeLabel: 'Período',
    rangeFrom: 'Primeiro mês',
    rangeTo: 'Último mês',
    refreshing: 'Atualizando o fluxo de caixa',
    cardsWithoutData: {
      notice_one:
        'O cartão {{name}} não tem fatura nem gastos recentes, então o fluxo não mostra valor para ele. Importe a fatura para incluí-lo.',
      notice_other:
        '{{count}} cartões não têm fatura nem gastos recentes, então o fluxo não mostra valor para eles: {{names}}. Importe as faturas para incluí-los.',
      more: 'mais {{count}}',
    },
    fx: {
      label: 'Câmbio usado: {{from}} → {{to}} {{rate}}',
      rateLine: '{{from}} → {{to}} {{rate}} · {{source}} de {{date}}',
      daily_one: 'Cada valor usa a cotação do seu dia: {{count}} cotação neste período.',
      daily_other: 'Cada valor usa a cotação do seu dia: {{count}} cotações neste período.',
      missing_one: '{{count}} valor sem cotação ficou fora dos totais.',
      missing_other: '{{count}} valores sem cotação ficaram fora dos totais.',
      missingShort: 'Sem cotação',
      incomplete_one: 'Os totais estão incompletos: {{count}} valor sem cotação ficou de fora.',
      incomplete_other:
        'Os totais estão incompletos: {{count}} valores sem cotação ficaram de fora.',
      incompleteUnknown: 'Os totais estão incompletos: há valores sem cotação que ficaram de fora.',
      more: '+{{count}}',
    },
    pageTitleWeekly: 'Fluxo de caixa semanal',
    view: { label: 'Período das colunas', month: 'Mensal', week: '13 semanas' },
    settings: {
      button: 'Configurações',
      title: 'Configurações do fluxo de caixa',
      view: 'Visão',
      rows: 'Linhas por',
      period: 'Período',
      scope: 'Entidade e moeda',
      accounts: 'Contas bancárias',
      accountsHelp:
        'Filtra os saldos e as transações do banco. Contas a pagar e a receber em aberto não têm conta bancária e continuam no fluxo.',
      accountsAll: 'Todas as contas',
      accountKind: { cash: 'Contas correntes', investment: 'Investimentos' },
      accountsSummary: '{{count}} de {{total}} contas',
      display: 'Exibição',
      amounts: 'Formato dos números',
      amountScale: {
        full: 'Completo',
        noCents: 'Sem centavos',
        thousands: 'Mil (K)',
        millions: 'Milhões (M)',
      },
      colorFlows: 'Entradas em verde e saídas em vermelho',
      expandedBalance: 'Mostrar saldo expandido',
      expandedBalanceHelp: 'Soma os investimentos ao saldo final, em linhas próprias.',
      reset: 'Restaurar padrão',
    },
    weekly: {
      balanceUnavailable:
        'Não há saldo bancário disponível para a data de referência. Saldos, menor saldo e runway não podem ser apurados; a tabela mostra as entradas e saídas de cada semana.',
      error: {
        title: 'Não foi possível carregar a projeção semanal',
        description: 'Tente de novo. Se o erro continuar, fale com o suporte.',
      },
      kpi: {
        label: 'Resumo das 13 semanas',
        opening: 'Saldo atual',
        lowest: 'Menor saldo projetado',
        lowestDetail: 'Na semana {{week}}',
        burn: 'Queima mensal',
        burnDetail: 'Média das 13 semanas',
        runway: 'Fôlego de caixa',
        runwayValue_one: '{{count}} mês',
        runwayValue_other: '{{count}} meses',
        runwayNone: 'Sem queima',
        runwayDetail: 'Saldo atual ÷ queima mensal',
        expanded: 'Caixa ampliado',
        expandedDetail: '{{amount}} em aplicações',
        confidence: 'Confiança da projeção',
        confidenceDetail: 'Em itálico: previsão, ainda sem documento',
      },
    },
    kpi: {
      label: 'Resumo do mês',
      expand: 'Mostrar resumo',
      opening: 'Saldo inicial',
      openingDetail: 'em {{date}}',
      inflow: 'Entradas',
      outflow: 'Saídas',
      toDate: 'até hoje',
      transfersDetail: 'até hoje · saldo das transferências entre contas: {{amount}}',
      current: 'Saldo hoje',
      currentDetail: 'saldo bancário de {{date}}',
      currentExpandedDetail: 'com investimentos: {{amount}}',
      reconciled: 'Conciliação',
      reconciledValue: '{{done}} de {{total}}',
      reconciledDetail: '{{count}} sem documento · {{amount}}',
      check: 'Conferência',
      checkOk: 'Confere',
      checkOkDetail:
        'saldo inicial + entradas + saídas + transferências + variação cambial = saldo final',
      checkGapDetail: 'diferença sem explicação',
      checkWithoutBalanceDetail_one: '{{count}} conta sem saldo do banco fora da conferência',
      checkWithoutBalanceDetail_other: '{{count}} contas sem saldo do banco fora da conferência',
    },
    months: {
      legendLabel: 'O que são realizado e previsto',
      viewLabel: 'Linhas por',
      managerial: 'Plano gerencial',
      taxonomy: 'Categoria',
      legend:
        'Realizado mostra o que passou no banco. Previsto mostra só o que já tem documento em aberto: meses distantes ficam menores.',
    },
    grid: {
      label: 'Fluxo de caixa por mês',
      loading: 'Carregando os meses…',
      columnAccount: 'Conta gerencial',
      columnCategory: 'Categoria',
      groupRealized: 'Realizado',
      groupCurrent: '{{month}} · hoje',
      groupCurrentWeek: 'Semana atual',
      groupProjected: 'Previsto',
      sideRealized: 'Realizado',
      sideCommitted: 'A realizar',
      cellAction: 'Ver detalhes de {{row}} em {{column}}: {{amount}}',
      maskedHelp: 'Você não tem acesso ao detalhe deste grupo. Só o total aparece.',
      unclassifiedHelp:
        'Transações bancárias ainda sem conta a pagar, a receber ou outro documento. Concilie para classificar.',
      unclassifiedManagerialHelp:
        'Transações sem documento conciliado e documentos sem conta gerencial. Concilie a transação ou classifique o documento.',
      internalTransfersHelp:
        'Transferências entre contas da própria empresa. Não mudam o caixa total.',
      fallbackHelp: 'Pagamentos sem conta gerencial, como parcelas de empréstimo.',
      openingBalance: 'Saldo inicial',
      section: { inflows: 'Entradas', outflows: 'Saídas', other: 'Outros movimentos' },
      netFlow: 'Variação do caixa',
      closingBalance: 'Saldo final',
      investments: 'Investimentos',
      investmentsHelp:
        'Saldo das contas de investimento no fim do período. Não entra no saldo final; nos meses futuros fica o último saldo conhecido.',
      expandedBalance: 'Saldo expandido',
      expandAll: 'Expandir tudo',
      collapseAll: 'Recolher tudo',
      check: 'Conferência',
      checkNotApplicable: 'Sem conferência: o mês ainda não passou no banco.',
      checkOk: 'OK',
      currencyTranslation: 'Efeito da variação cambial',
      currencyTranslationHelp:
        'Contas em outra moeda: cada saldo é convertido pela cotação da data dele, e cada transação pela cotação do dia dela. Esta linha é a diferença que vem só da mudança da cotação, com o arredondamento da conversão. É uma linha de conferência gerencial, não a linha da DFC.',
      withoutBalance: 'Contas sem saldo do banco',
      withoutBalanceHelp:
        'Contas com transações no mês, mas sem saldo informado pelo banco no início ou no fim do mês. O saldo que falta conta como zero nos saldos inicial e final, então esta linha é o caixa que eles deixam de fora, não uma diferença. Essas contas ficam fora da conferência. Numa conta em outra moeda, o efeito da cotação dela também fica nesta linha.',
      withoutBalanceHelpWithAccounts:
        'Contas com transações no mês, mas sem saldo informado pelo banco no início ou no fim do mês. O saldo que falta conta como zero nos saldos inicial e final, então esta linha é o caixa que eles deixam de fora, não uma diferença. Essas contas ficam fora da conferência. Numa conta em outra moeda, o efeito da cotação dela também fica nesta linha. Contas: {{accounts}}.',
      checkOkHelp:
        'O saldo final do banco é igual ao saldo inicial mais o movimento do mês e a variação cambial.',
      checkGapHelp:
        'O saldo do banco não fecha com o movimento do mês. Verifique transações faltando ou saldos desatualizados.',
    },
    drilldown: {
      title: '{{row}} · {{month}}',
      realizedSubtitle: 'Transações bancárias do mês nesta linha.',
      committedSubtitle: 'Contas a pagar e a receber em aberto com vencimento no mês.',
      error: 'Não foi possível carregar os detalhes.',
      empty: 'Nenhum item nesta célula.',
      tableLabel: 'Itens da célula',
      loading: 'Carregando os itens…',
      columnDate: 'Data',
      columnDescription: 'Descrição',
      columnStatus: 'Situação',
      columnAmount: 'Valor',
      share: '{{source}} · {{percent}} do documento',
      withheld_one:
        '{{count}} item de folha é confidencial e não aparece. O total inclui esse item.',
      withheld_other:
        '{{count}} itens de folha são confidenciais e não aparecem. O total inclui esses itens.',
      status: {
        reconciled: 'Conciliado',
        unreconciled: 'Sem documento',
        toPay: 'A pagar',
        processing: 'Em processamento',
        toReceive: 'A receber',
      },
      statusHelp: {
        reconciled: 'A transação bancária está ligada a um documento.',
        unreconciled: 'A transação bancária ainda não tem documento.',
        toPay: 'Conta a pagar em aberto.',
        processing: 'Pagamento enviado ao banco, ainda sem débito no extrato.',
        toReceive: 'Conta a receber em aberto.',
      },
    },
    empty: {
      title: 'Nenhuma conta bancária conectada',
      description: 'Conecte uma conta bancária para ver o caixa realizado mês a mês.',
      descriptionNoAccess:
        'Ainda não há conta bancária conectada. Peça a quem administra as contas bancárias para conectar uma.',
      action: 'Conectar conta bancária',
    },
    noResults: {
      title: 'Nenhuma movimentação nestes meses',
      description: 'Escolha um período maior para ver meses com movimento.',
      action: 'Ver 12 meses para cada lado',
    },
    error: {
      title: 'Não foi possível carregar o fluxo de caixa',
      description: 'Tente de novo em alguns instantes.',
    },
  },
};

export const cashflowEn = {
  filters: {
    excludeUnscheduled: 'Exclude balances without registered payments',
    excludedSummary:
      '{{count}} bill(s) with excluded balance: {{amount}}. Future recurring forecasts remain included.',
  },
  fx: {
    historicalRecovery:
      'This item needs a historical closing quote. Resolve it in the FX recovery center.',
    openRecovery: 'Open FX recovery',
    unknownCurrency: 'Unspecified currency',
    title: 'Projection exchange rates',
    rate: 'Rate',
    date: 'Quote date',
    source: 'Source',
    incomplete:
      'Incomplete projection: some amounts could not be converted. Totals and indicators are unavailable until these items are resolved.',
    subtotals: 'Converted subtotals — these do not represent the complete cash flow',
    manualQuote: 'Enter exchange rate',
    editRate: 'Edit',
    currency: 'Reporting currency',
    unresolved: 'Amounts awaiting conversion',
    pending:
      'Quote submitted for approval by another person. The projection will use it after approval.',
  },
  title: 'Cash Flow',
  subtitle: 'Consolidated projection · {{date}}',
  entitySubtitle: 'Entity projection · {{date}}',
  entity: {
    allConsolidated: 'All entities (consolidated)',
    entityA: 'Alchemy Tecnologia Ltda',
    entityB: 'Alchemy Filial SP',
  },
  period: {
    weeks: '13 weeks',
    days: '14 days',
  },
  actions: {
    manualEntry: 'Manual entry',
    export: 'Export',
    exportToast: 'Export is not available yet in this version.',
  },
  alerts: {
    bannerLabel: 'Cash flow notices',
    openWarnings: 'Warnings: {{label}}',
    warningDetails: 'Review the limitations and pending items affecting these figures.',
    bankBalanceUnavailable:
      'No bank balance is available for the reference date. Cash and runway cannot be determined; the table shows cumulative inflow and outflow changes without an opening balance.',
    bankConnectionExpired:
      '{{bank}} connection expired — this account’s data reflects {{date}}. The consolidated balance may be stale.',
    bankConnectionExpiredNoSync:
      '{{bank}} connection hasn’t synced yet. The consolidated balance may be stale.',
    bankConnectionPendingAuth:
      'Open finance - Your bank is awaiting authorization; the consolidated balance may be out of date.',
    unknownBank: 'your banking institution',
    openPluggy: 'Integrations',
    liquidityGap: {
      title: '{{entityName}}: projected balance falls below the liquidity floor',
      message:
        'In period {{week}}, the projected balance is {{shortfall}} below the {{floor}} floor.',
      leversLabel: 'Recommended actions (suggestions only — none execute automatically):',
    },
    idleCash: {
      title: '{{entityName}}: idle cash detected',
      message:
        'The consolidated balance is {{balance}}, above the {{threshold}} floor+buffer for {{days}} consecutive days. This may be an opportunity to put the surplus to work.',
    },
  },
  summary: {
    currentBalance: {
      label: 'Current consolidated balance',
      hint: '{{accounts}} · {{freshness}}',
      noAccounts: 'no accounts',
      accountsCount_one: '{{count}} {{currency}} account',
      accountsCount_other: '{{count}} {{currency}} accounts',
      noData: 'no balance data',
      updatedToday: 'updated today',
      updatedOn: 'updated on {{date}}',
    },
    balanceUnavailable: 'Unavailable',
    expandedCash: {
      label: 'Expanded cash',
      hint: 'includes {{amount}} in D+0 investments',
      tooltip:
        'A liquidity view that sums the checking-account balance with financial investments that can be redeemed immediately or near-immediately. It answers "how much can I mobilize today if I need to?" instead of just "how much is sitting in the account." You can edit which investments count',
      tooltipLink: 'Here.',
    },
    burn: {
      label: 'Monthly net burn',
      hint: 'monthly average of projected net cash outflows',
    },
    runway: {
      label: 'Runway',
      hint: 'expanded cash ÷ average burn',
      months: '{{value}} months',
      notBurning: 'Not burning cash',
    },
    lowestBalance: {
      label: 'Lowest projected balance',
      hint: 'week of {{range}}',
      dailyHint: 'day {{range}}',
    },
  },
  table: {
    title: 'Weekly projection · 13 weeks',
    dailyTitle: 'Daily projection · 14 days',
    confidence: 'Projection confidence: {{value}}%',
    confidenceHelp:
      'Indicative score by value source: Realized {{realized}}, Committed {{committed}}, Forecast {{forecastAi}} and Planned {{planned}}.\n\nThese scores are averaged, weighted by the absolute value of each category cell in the displayed period. A cell containing multiple classifications uses the lowest score. Empty or zero cells are excluded; with no values, the score is 0%.\n\nThis is not a probability of accuracy: it does not measure missing data, date quality or historical errors.',
    legend: {
      realized: 'Realized',
      committed: 'Committed',
      forecastAi: 'Forecast',
      planned: 'Planned',
    },
    legendHelp: {
      realized: 'An actual cash inflow or outflow, supported by a payment or receipt record.',
      committed:
        'An amount from an existing document, such as a payable or receivable. A payment may not be registered yet, and its date may be estimated.',
      forecastAi:
        'An estimate generated from recurring bills, purchase orders, contracts or payroll, before the corresponding payable or receivable exists. The document replaces the estimate when created.',
      planned:
        'A manual entry included in the projection. It is not cleared automatically: adjust or remove it when the corresponding document is recorded to avoid double counting.',
    },
    viewMode: {
      managerial: 'Managerial view (burn)',
      detailed: 'Detailed operational view',
    },
    columns: {
      category: 'Category',
    },
    sections: {
      inflows: 'Inflows',
      outflows: 'Outflows',
    },
    rows: {
      totalInflows: 'Total inflows',
      totalOutflows: 'Total outflows',
      netChange: 'Net change',
      closingBalance: 'Projected closing balance',
      cumulativeNetChange: 'Cumulative change (without opening balance)',
    },
    footnote:
      'Forecasted dates are adjusted based on each customer’s payment behavior. Click any cell to see source documents.',
    dateEstimatedHint:
      'Includes dates estimated from due dates, historical payments, or payment assumptions. See the drill-down for their source.',
    amountEstimatedHint:
      'Includes estimated amounts that may differ from actual payments. See the drill-down for their source and assumptions.',
    memoRowHint:
      'Memo row: these amounts are not included in the totals, the projected balance or the alerts. Click to see the documents.',
    payrollForecastHint:
      "May include Alchemy ERP's own payroll forecast — see the cell's drill-down for detail.",
    payrollCalendarNotConfigured:
      'No payment calendar configured for this stream — projected on the statutory default days.',
    payrollCalendarNotConfiguredLink: 'Configure payment calendar',
  },
  drilldown: {
    contracts_one: 'Contract: {{codes}}',
    contracts_other: 'Contracts: {{codes}}',
    inferredDue: 'Inferred due date',
    editCashTiming: 'Click to change the configuration.',
    cashCalendarWeekdays: 'weekdays (0 = Sunday)',
    cashCalendarMonthDays: 'days of month',
    cashDateBasis: {
      DOCUMENT_DUE_DATE: 'documentary due dates',
      SCHEDULED_DATE: 'scheduled dates',
      MIXED: 'documentary due dates and scheduled dates',
    },
    cashDateSources: {
      MANUAL_TERM: 'Manual term: competency + {{days}} calendar days.',
      HISTORICAL_TERM:
        'Recurring history: competency + {{days}} days. Median of {{count}} competencies, using {{basis}}.',
      ENTITY_CALENDAR: 'Next entity calendar date after competency: {{calendar}} — {{dates}}.',
      COMPETENCY_FALLBACK: 'No term, history or calendar. Uses competency itself (D+0).',
    },

    title: '{{category}} · {{week}}',
    loading: 'Loading documents…',
    description: 'Source documents contributing to this cell.',
    filters: {
      filter: 'Filter {{column}}',
      search: 'Search vendor or description',
      all: 'All classifications',
      minimum: 'Minimum amount',
      maximum: 'Maximum amount',
      signedAmounts:
        'Use negative values for outflows and positive values for inflows, in the reporting currency.',
      clearAll: 'Clear filters and sorting',
    },
    projectionDateHelp: 'How the projection date is determined',
    projectionDateTooltip:
      'Date when the amount is included in cash flow.\n\nScheduled payment: scheduled date.\nBill without a scheduled payment: due date; if missing, an estimate based on payment terms or the default lead time.\nActual transaction: bank posting date.\n\nOutstanding items dated before the projection starts are allocated to the start of the first week. In that case, the displayed date is neither the original due date nor a new payment schedule.',
    columns: {
      document: 'Document',
      date: 'Projection date',
      dueDate: 'Due date',
      scheduledDate: 'Scheduled',
      paymentSentAt: 'Payment sent',
      layer: 'Classification',
      amount: 'Amount',
    },
    paymentStates: {
      AWAITING_BANK_CONFIRMATION: 'Awaiting payment confirmation',
      FAILED: 'Failed – resend',
    },
    paymentStatesHelp: {
      AWAITING_BANK_CONFIRMATION:
        'The payment was sent to the bank and is awaiting confirmation. The amount stays committed.',
      FAILED:
        'The bank rejected the payment. Resend it so it goes out on the planned date. The amount stays committed.',
    },
    loadError: 'Could not load the source documents.',
    empty: 'No documents found for this cell.',
    openSource: 'Open source document',
    documentTypes: {
      bankTransaction: 'Bank transaction',
      apPayment: 'Vendor payment',
      apBill: 'Payable bill (estimated date)',
      cardStatement: 'Card statement',
      loanInstallment: 'Loan installment',
      arSchedule: 'Receivable',
      cfManualItem: 'Manual entry',
      apVendorRecurringBill: 'Recurrence',
      purchaseOrder: 'Purchase order (forecast)',
      hcmPayrollForecast: 'Projected payroll (forecast)',
      // ALC-4194 (ADR 0018) — a card with no live statement: the estimate comes from payments and bills.
      uncoveredCardEstimate: 'Card without a statement (estimated)',
      costProvision: 'Provisioned cost',
    },
    // ALC-4194 — the parts of an uncovered card's estimate. "Credit" parts reduce the estimate
    // (statements already paid, a statement payment that already leaves the bank).
    uncoveredCardComponents: {
      UNCOVERED_CARD_CYCLE_CHARGES: 'Card charges in the last 2 billing cycles',
      UNCOVERED_CARD_PAID_INVOICES: 'Credit: statements already paid',
      UNCOVERED_CARD_OPEN_BILLS: 'Open bills',
      UNCOVERED_CARD_SCHEDULED_INVOICE_PAYMENTS: 'Credit: statement payment scheduled at the bank',
    },
    uncoveredCardEstimateNotice:
      'Estimated from payments and bills. Import the card statement to see the exact amount.',
    probableCardReasons: {
      VENDOR_LAST_PAID_BY_CARD: 'Last payment was by card',
      CARD_MATCH_CANDIDATE: 'Card reconciliation match suggested',
    },
    // ALC-4191 (D9) — the memo row keeps the trace of the category the bill came from.
    originCategory: 'From: {{category}}',
    payrollForecast: {
      sourceRunPeriod: 'Based on the {{period}} payroll',
      noSourceRunPeriod: 'No reference payroll',
    },
    // ALC-4192 — fatura remainder breakdown shown on a CARD_STATEMENT drill-down row.
    cardStatementBreakdown: {
      // ALC-4192 — "line" not "statement": on the fees/IOF row this is the fees total, not the
      // whole statement's total. Payment settles the principal row first and only spills onto
      // this one once the principal is covered, so its "Pago" is usually — but not always — 0.
      total: 'Line total',
      paid: 'Paid',
      remainder: 'Remaining',
    },
  },
  // ALC-3561 — copy for the payroll forecast contract. Keys mirror the producer's stable
  // warning codes 1:1; the API never sends a message, only the code.
  payrollForecast: {
    streams: {
      NET: 'Net pay',
      ADVANCE: 'Salary advance',
      PRO_LABORE: 'Pró-labore',
      RPA: 'RPA (contractors)',
      REPASSE: 'Third-party remittances',
      THIRTEENTH_1: '13th salary — 1st installment',
      THIRTEENTH_2: '13th salary — 2nd installment',
      TERMINATION: 'Termination pay',
    },
    sources: {
      ROLL_FORWARD: 'Projected from the last payroll run',
      PLAN_POSITION: 'Position from the hiring plan',
      TERMINATION_ADJUSTMENT: 'Termination adjustment',
      PROCESSED_RUN: 'Processed payroll run, awaiting posting',
    },
    ferias: {
      label: 'Vacation provision',
      undatedTitle: 'Obligations without a payment schedule',
      undatedHint:
        'Accounting balances for reference. Excluded from outflows and projected cash balances.',
      byEntity: 'Breakdown by entity',
      entityUnavailable: 'Unidentified entity',
      unavailable: 'Balance unavailable. Check the warnings for the required data.',
      // The figure is the provision balance only — INSS/FGTS over the provision is not in it.
      hint: 'Accrued accounting provision with no payment date. Excluded from weekly outflows and projected cash balances. Excludes INSS/FGTS charged over the provision.',
      value: '{{amount}} · no date',
      flagged:
        'The provision balance is negative in the ledger — shown as zero. Review the entries.',
      mixedCurrency:
        'Entities have different functional currencies — a consolidated total is unavailable.',
      byEntityLine: '{{entityName}}: {{amount}}',
    },
    warnings: {
      PAYROLL_CALENDAR_DECLARED_NO_RUN:
        'A payment calendar is declared, but no payroll run exists in the last 2 competências — nothing was projected for this stream.',
      PAYROLL_RUN_NOT_IN_CALENDAR:
        'This stream has payroll runs but is not declared in the payment calendar — projected on the statutory default day.',
      PAYROLL_CALENDAR_NOT_CONFIGURED:
        'No payment calendar is configured — projected on the statutory default days.',
      PAYROLL_FORECAST_CONFIDENTIAL:
        'Details are hidden by your access level. Aggregate alerts: {{coverageIssueCount}} coverage and {{estimateIssueCount}} assumption or staleness.',
      PAYROLL_NEW_HIRES_AFTER_LAST_RUN:
        'There are hires after the last payroll run. The projection does not reflect those contracts yet.',
      PAYROLL_LAST_RUN_STALE:
        'The latest payroll run for this entity is more than 2 competências old. The projected amount may be out of date.',
      PAYROLL_ROSTER_UNAVAILABLE:
        'The FP&A headcount roster could not be loaded for this entity — the projection accounts for neither planned hires nor planned departures.',
      PAYROLL_MONTHLY_BASE_MISSING:
        'A CLT advance exists, but no monthly payroll is available to estimate remaining salary and thirteenth salary. Payroll coverage is incomplete; import the monthly payroll to complete the base.',
      PAYROLL_FERIAS_UNAVAILABLE: 'The vacation provision could not be computed for this entity.',
      PAYROLL_FERIAS_MIXED_CURRENCY:
        'The selected entities do not share one functional currency — the vacation total is not summed.',
      PAYROLL_RUN_CURRENCY_MISMATCH:
        "The latest payroll run is denominated in a currency other than the entity's functional currency and was skipped — nothing projected for this stream.",
      PAYROLL_RUN_TOTAL_MISMATCH:
        'The payroll header total differs from the result sum. The forecast uses the results, matching payroll posting.',
      PAYROLL_REPASSE_MAPPING_UNAVAILABLE:
        'Remittances could not be verified because the accounting book or period is unavailable. Net payroll remains in the projection.',
      PAYROLL_REPASSE_PENDING_POSTING:
        'The payroll contains deductions payable to third parties but is not posted yet. These remittances are projected at the withheld amount until their bills are generated.',
      PAYROLL_FX_RATE_UNAVAILABLE:
        "No FX rate was available to convert this entity's payroll into the report currency as of the reference date — the projection is incomplete and the row remains in the unresolved items list.",
      PAYROLL_PROCESSED_OVERDUE_UNBILLED:
        'The expected payment date has passed and the processed payroll has no bills yet. Its net amount remains pending in the current week; this does not confirm that bank payment is missing.',
      PAYROLL_THIRTEENTH_NET_BELOW_PARCELA_1:
        'The base run pays out less net than the first 13º instalment, so the second was estimated at the same amount as the first — December may read slightly high; check the base run.',
    },
    banner: {
      title: 'Payroll forecast warnings',
      withEntity: '{{entityName}}: {{message}}',
      runContext: 'Period {{period}} · {{runType}} · expected payment {{cashDate}}',
      dateUnknown: 'not specified',
    },
  },
  categories: {
    clientPayments: 'Customer receipts',
    recurringContracts: 'Recurring contracts (to invoice)',
    oneOffServices: 'One-off services (forecast)',
    suppliers: 'Suppliers',
    payroll: 'Payroll & charges',
    taxes: 'Taxes & filings',
    cardBills: 'Credit card bills',
    cardFinanceCharges: 'Card interest and finance charges',
    loans: 'Loans',
    bankFees: 'Bank fees',
  },
  manualEntry: {
    title: 'New manual entry',
    description:
      'Record an expected inflow or outflow that isn’t reflected automatically in the cash flow yet.',
    directionLabel: 'Entry type',
    inflow: 'Inflow',
    outflow: 'Outflow',
    entityLabel: 'Entity',
    categoryLabel: 'Category',
    categoryPlaceholder: 'Select a category',
    categoryOther: 'Other',
    activityLabel: 'CPC-03 activity',
    activityPlaceholder: 'Select the economic activity',
    activityOperating: 'Operating',
    activityInvesting: 'Investing',
    activityFinancing: 'Financing',
    dateLabel: 'Expected date',
    amountLabel: 'Amount',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Entry details (optional)',
    cancel: 'Cancel',
    save: 'Save entry',
    update: 'Save changes',
    edit: 'Edit',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete planned entry?',
    deleteConfirmDescription:
      'The entry will be removed from the cash-flow projection. This cannot be undone.',
    deleteConfirmAction: 'Delete',
    itemsTitle: 'Planned entries',
    deletedToast: 'Entry removed from the cash flow.',
    deleteErrorToast: 'Could not delete the entry.',
    loadError: 'Could not load the entry data.',
    retry: 'Retry',
    savedToast: 'Entry added to the cash flow.',
    saveErrorToast: 'Could not save the entry. Please try again.',
    loading: 'Loading entities…',
    noEntities: 'No entities found.',
  },
  liquidityConfig: {
    trigger: 'Liquidity floor',
    title: 'Liquidity floor',
    description:
      'Set the minimum balance per entity. An alert fires whenever a projected week’s balance falls below this floor.',
    entityLabel: 'Entity',
    floorLabel: 'Liquidity floor',
    suggestedHint: 'Suggested from the current monthly burn. You can adjust it before saving.',
    bufferLabel: 'Idle cash buffer',
    sustainedDaysLabel: 'Sustained days',
    cancel: 'Cancel',
    save: 'Save',
    savedToast: 'Liquidity floor saved.',
    saveErrorToast: 'Could not save the liquidity floor.',
    loading: 'Loading…',
    loadError: 'Could not load the configuration.',
    retry: 'Retry',
    noEntities: 'No entities registered yet to configure a liquidity floor.',
  },
  monthly: {
    pageTitle: 'Monthly cash flow',
    entityLabel: 'Entity',
    rangeLabel: 'Period',
    rangeFrom: 'First month',
    rangeTo: 'Last month',
    refreshing: 'Updating the cash flow',
    cardsWithoutData: {
      notice_one:
        'The card {{name}} has no statement and no recent charges, so the cash flow shows no amount for it. Import the statement to include it.',
      notice_other:
        '{{count}} cards have no statement and no recent charges, so the cash flow shows no amount for them: {{names}}. Import the statements to include them.',
      more: '{{count}} more',
    },
    fx: {
      label: 'Exchange rate used: {{from}} → {{to}} {{rate}}',
      rateLine: '{{from}} → {{to}} {{rate}} · {{source}} on {{date}}',
      daily_one: 'Each amount uses the rate of its own day: {{count}} rate in this period.',
      daily_other: 'Each amount uses the rate of its own day: {{count}} rates in this period.',
      missing_one: '{{count}} amount with no rate is left out of the totals.',
      missing_other: '{{count}} amounts with no rate are left out of the totals.',
      missingShort: 'No rate',
      incomplete_one: 'Totals are incomplete: {{count}} amount with no rate is left out.',
      incomplete_other: 'Totals are incomplete: {{count}} amounts with no rate are left out.',
      incompleteUnknown: 'Totals are incomplete: amounts with no rate are left out.',
      more: '+{{count}}',
    },
    pageTitleWeekly: 'Weekly cash flow',
    view: { label: 'Column period', month: 'Monthly', week: '13 weeks' },
    settings: {
      button: 'Settings',
      title: 'Cash flow settings',
      view: 'View',
      rows: 'Rows by',
      period: 'Period',
      scope: 'Entity and currency',
      accounts: 'Bank accounts',
      accountsHelp:
        'Filters bank balances and transactions. Open payables and receivables have no bank account and stay in the flow.',
      accountsAll: 'All accounts',
      accountKind: { cash: 'Checking accounts', investment: 'Investments' },
      accountsSummary: '{{count}} of {{total}} accounts',
      display: 'Display',
      amounts: 'Number format',
      amountScale: {
        full: 'Full',
        noCents: 'No cents',
        thousands: 'Thousands (K)',
        millions: 'Millions (M)',
      },
      colorFlows: 'Money in green and money out red',
      expandedBalance: 'Show expanded balance',
      expandedBalanceHelp: 'Adds investments to the closing balance, on their own rows.',
      reset: 'Restore defaults',
    },
    weekly: {
      balanceUnavailable:
        'No bank balance is available for the reference date. Balances, lowest balance and runway cannot be determined; the table shows each week’s inflows and outflows.',
      error: {
        title: 'Could not load the weekly forecast',
        description: 'Try again. If the error continues, contact support.',
      },
      kpi: {
        label: '13-week summary',
        opening: 'Current balance',
        lowest: 'Lowest projected balance',
        lowestDetail: 'In the week {{week}}',
        burn: 'Monthly burn',
        burnDetail: 'Average of the 13 weeks',
        runway: 'Cash runway',
        runwayValue_one: '{{count}} month',
        runwayValue_other: '{{count}} months',
        runwayNone: 'No burn',
        runwayDetail: 'Current balance ÷ monthly burn',
        expanded: 'Expanded cash',
        expandedDetail: '{{amount}} in investments',
        confidence: 'Forecast confidence',
        confidenceDetail: 'In italics: forecast, no document yet',
      },
    },
    kpi: {
      label: 'Month summary',
      expand: 'Show summary',
      opening: 'Opening balance',
      openingDetail: 'on {{date}}',
      inflow: 'Inflows',
      outflow: 'Outflows',
      toDate: 'so far',
      transfersDetail: 'so far · net transfers between accounts: {{amount}}',
      current: 'Balance today',
      currentDetail: 'bank balance of {{date}}',
      currentExpandedDetail: 'with investments: {{amount}}',
      reconciled: 'Reconciliation',
      reconciledValue: '{{done}} of {{total}}',
      reconciledDetail: '{{count}} with no document · {{amount}}',
      check: 'Check',
      checkOk: 'Matches',
      checkOkDetail: 'opening + inflows + outflows + transfers + exchange-rate effect = closing',
      checkGapDetail: 'unexplained difference',
      checkWithoutBalanceDetail_one: '{{count}} account with no bank balance left out of the check',
      checkWithoutBalanceDetail_other:
        '{{count}} accounts with no bank balance left out of the check',
    },
    months: {
      legendLabel: 'What actual and forecast mean',
      viewLabel: 'Rows by',
      managerial: 'Managerial chart',
      taxonomy: 'Category',
      legend:
        'Actuals show what went through the bank. Forecast shows only documents that are still open, so far months look smaller.',
    },
    grid: {
      label: 'Cash flow by month',
      loading: 'Loading the months…',
      columnAccount: 'Managerial account',
      columnCategory: 'Category',
      groupRealized: 'Actuals',
      groupCurrent: '{{month}} · today',
      groupCurrentWeek: 'This week',
      groupProjected: 'Forecast',
      sideRealized: 'Actual',
      sideCommitted: 'Still to come',
      cellAction: 'See the detail of {{row}} in {{column}}: {{amount}}',
      maskedHelp: 'You cannot see the detail of this group. Only the total shows.',
      unclassifiedHelp:
        'Bank transactions with no payable, receivable or other document yet. Reconcile them to classify them.',
      unclassifiedManagerialHelp:
        'Transactions with no reconciled document and documents with no managerial account. Reconcile the transaction or classify the document.',
      internalTransfersHelp:
        'Transfers between the company’s own accounts. They do not change total cash.',
      fallbackHelp: 'Payments with no managerial account, such as loan installments.',
      openingBalance: 'Opening balance',
      section: { inflows: 'Inflows', outflows: 'Outflows', other: 'Other movements' },
      netFlow: 'Net cash flow',
      closingBalance: 'Closing balance',
      investments: 'Investments',
      investmentsHelp:
        'Balance of the investment accounts at the end of the period. Not in the closing balance; future months keep the latest known balance.',
      expandedBalance: 'Expanded balance',
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      check: 'Check',
      checkNotApplicable: 'No check: the month has not gone through the bank yet.',
      checkOk: 'OK',
      currencyTranslation: 'Exchange-rate effect',
      currencyTranslationHelp:
        'Accounts in another currency: each balance is converted at the rate of its date, and each transaction at the rate of its day. This row is the difference that comes only from the rate change, with the conversion rounding. It is a management reconciling line, not the cash flow statement line.',
      withoutBalance: 'Accounts with no bank balance',
      withoutBalanceHelp:
        'Accounts with transactions in the month but no balance from the bank at its start or end. The missing balance counts as zero in the opening and closing balances, so this row is the cash they leave out, not a gap. These accounts are left out of the check. For an account in another currency, its exchange-rate effect is on this row too.',
      withoutBalanceHelpWithAccounts:
        'Accounts with transactions in the month but no balance from the bank at its start or end. The missing balance counts as zero in the opening and closing balances, so this row is the cash they leave out, not a gap. These accounts are left out of the check. For an account in another currency, its exchange-rate effect is on this row too. Accounts: {{accounts}}.',
      checkOkHelp:
        'The bank closing balance equals the opening balance plus the month’s movement and the exchange-rate effect.',
      checkGapHelp:
        'The bank balance does not match the month’s movement. Look for missing transactions or stale balances.',
    },
    drilldown: {
      title: '{{row}} · {{month}}',
      realizedSubtitle: 'Bank transactions of the month in this row.',
      committedSubtitle: 'Open payables and receivables due in the month.',
      error: 'Could not load the detail.',
      empty: 'No items in this cell.',
      tableLabel: 'Cell items',
      loading: 'Loading the items…',
      columnDate: 'Date',
      columnDescription: 'Description',
      columnStatus: 'Status',
      columnAmount: 'Amount',
      share: '{{source}} · {{percent}} of the document',
      withheld_one:
        '{{count}} payroll item is confidential and is not listed. The total includes it.',
      withheld_other:
        '{{count}} payroll items are confidential and are not listed. The total includes them.',
      status: {
        reconciled: 'Reconciled',
        unreconciled: 'No document',
        toPay: 'To pay',
        processing: 'Processing',
        toReceive: 'To receive',
      },
      statusHelp: {
        reconciled: 'The bank transaction is linked to a document.',
        unreconciled: 'The bank transaction has no document yet.',
        toPay: 'Open payable.',
        processing: 'Payment sent to the bank, not on the statement yet.',
        toReceive: 'Open receivable.',
      },
    },
    empty: {
      title: 'No bank account connected',
      description: 'Connect a bank account to see actual cash month by month.',
      descriptionNoAccess:
        'No bank account is connected yet. Ask whoever manages bank accounts to connect one.',
      action: 'Connect a bank account',
    },
    noResults: {
      title: 'No movement in these months',
      description: 'Pick a longer period to see months with movement.',
      action: 'See 12 months each side',
    },
    error: {
      title: 'Could not load the cash flow',
      description: 'Try again in a moment.',
    },
  },
};
